import { render, staticRenderFns } from "./AddCompanyModal.vue?vue&type=template&id=b6017302&"
import script from "./AddCompanyModal.vue?vue&type=script&lang=js&"
export * from "./AddCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports